import { Client } from 'src/api/Client';
import {
  CompleteMultipartUploadRequest,
  GenerateMultipartUploadRequest,
  GenerateMultipartUploadResponse,
  MediaObject,
  MediaTemporaryUrlsResponse,
} from './MediaClient.types';
import { AxiosRequestConfig } from 'axios';

class MediaClient extends Client {
  public readonly route = {
    getTemporaryUrls: `${this.http.baseUrl}/media/{model}`,
    generateMultipartUpload: `${this.http.baseUrl}/media/{model}`,
    completeMultipartUpload: `${this.http.baseUrl}/media/{model}`,
    cancelUpload: `${this.http.baseUrl}/ai-agent/media/{mediaId}/cancel`,
    share: `${this.http.baseUrl}/media/{model}/share`,
    getMediaLibrary: `${this.http.baseUrl}/media/library`,
  };

  getTemporaryUrls: (
    model: string,
    config?: AxiosRequestConfig,
  ) => Promise<MediaTemporaryUrlsResponse> = (model, config) => {
    return this.http.get(this.buildUrl(this.route.getTemporaryUrls, { model }), config);
  };

  generateMultipartUpload = (
    model: string,
    data: GenerateMultipartUploadRequest,
  ): Promise<GenerateMultipartUploadResponse> => {
    return this.http.post(this.buildUrl(this.route.generateMultipartUpload, { model }), data);
  };

  completeMultipartUpload = (
    model: string,
    data: CompleteMultipartUploadRequest,
    controller?: AbortController,
  ): Promise<void> => {
    return this.http.put(this.buildUrl(this.route.completeMultipartUpload, { model }), data, {
      signal: controller?.signal,
    });
  };

  cancelUpload = (mediaId: string): Promise<void> => {
    return this.http.post(this.buildUrl(this.route.cancelUpload, { mediaId }));
  };

  share = (model: string): Promise<string> =>
    this.http.post(this.buildUrl(this.route.share, { model }));

  getMediaLibrary = (params?: {
    collection_name?: string;
    type?: 'image' | 'video' | 'audio';
  }): Promise<MediaObject[]> => {
    return this.http.get(this.route.getMediaLibrary, { params });
  };
}

export default MediaClient;
